import $ from 'jquery';
export default {
	init() {
		var $solutionswrapper = $('#solutions-inner'),
			$solutionsnavigation = $('.solutions-navigation'),
			scrollTop = $(window).scrollTop(),
			windowHeight = $(window).height(),
			solutionsTop = $solutionswrapper.offset().top,
			solutionsBottom =
				solutionsTop + $solutionswrapper.height() - $(window).height();
		$(window).scroll(function () {
			(scrollTop = $(window).scrollTop()),
				(windowHeight = $(window).height()),
				(solutionsTop = $solutionswrapper.offset().top),
				(solutionsBottom =
					solutionsTop + $solutionswrapper.outerHeight() - windowHeight);
			if (scrollTop > solutionsTop && scrollTop < solutionsBottom) {
				$solutionsnavigation.addClass('stuck');
			} else {
				$solutionsnavigation.removeClass('stuck');
			}
			if (scrollTop > solutionsBottom) {
				$solutionsnavigation.addClass('bottom');
			} else {
				$solutionsnavigation.removeClass('bottom');
			}
			$('.solutions-item').each(function () {
				let $this = $(this),
					thisTop = $this.offset().top,
					thisBottom = thisTop + $this.height();
				if (
					windowHeight / 2 + scrollTop > thisTop &&
					thisBottom > scrollTop + windowHeight / 2
				) {
					$this.addClass('active');
					$('.solutions-nav-toggle').removeClass('active');
					$(
						'.solutions-nav-toggle[data-id="' + $this.attr('data-item') + '"]'
					).addClass('active');
				} else {
					$this.removeClass('active');
				}
			});
		});
		$('.solutions-nav-toggle').click(function () {
			$('html, body')
				.stop()
				.animate(
					{
						scrollTop:
							$('[data-item="' + $(this).attr('data-id') + '"]').offset().top -
							100,
					},
					1500
				);
		});
	},
	finalize() {},
};
